import { Calendar, Percent } from 'lucide-react';

import { ICON_PROPS, PaymentPoint } from '../constants';

export const POINTS: PaymentPoint[] = [
  {
    icon: <Calendar {...ICON_PROPS} />,
    text: 'Repayments start after the job has been completed',
  },
  {
    icon: <Percent {...ICON_PROPS} />,
    text: 'Choose your preferred payment term',
  },
];
